(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbx-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cbx-carousel')) {
    customElements.define('cbx-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.viewport = this.querySelector('[data-cbx-carousel-viewport]');
        this.track = this.querySelector('[data-cbx-carousel-track]');
        this.previousButton = this.querySelector('[data-cbx-carousel-previous]');
        this.nextButton = this.querySelector('[data-cbx-carousel-next]');
        this.cards = this.track ? Array.from(this.track.children) : [];
        this.activeIndex = 0;

        if (!this.viewport || this.cards.length === 0) return;

        const signal = this.abortController.signal;
        this.previousButton?.addEventListener('click', () => this.move(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.move(1), { signal });
        this.viewport.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1);
          }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = this.cards.find((item) => item === event.target || item.contains(event.target));
          if (card) this.scrollToCard(this.cards.indexOf(card));
        }, { signal });

        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this.viewport);
        this.updateActiveCard();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.updateFrame);
      }

      queueUpdate() {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.updateActiveCard());
      }

      updateActiveCard() {
        const alignStart = this.dataset.alignment === 'start';
        const viewportCenter = this.viewport.scrollLeft + (alignStart ? 24 : this.viewport.clientWidth / 2);
        let closestDistance = Number.POSITIVE_INFINITY;
        let closestIndex = 0;

        this.cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft + (alignStart ? 0 : card.offsetWidth / 2);
          const distance = Math.abs(cardCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.activeIndex = closestIndex;
        this.cards.forEach((card, index) => card.classList.toggle('is-active', index === closestIndex));
        if (this.previousButton) this.previousButton.disabled = closestIndex === 0;
        if (this.nextButton) this.nextButton.disabled = closestIndex === this.cards.length - 1;
      }

      move(direction) {
        const targetIndex = Math.max(0, Math.min(this.cards.length - 1, this.activeIndex + direction));
        this.scrollToCard(targetIndex);
      }

      scrollToCard(index) {
        const card = this.cards[index];
        if (!card) return;
        const left = card.offsetLeft - (this.dataset.alignment === 'start' ? 24 : (this.viewport.clientWidth - card.offsetWidth) / 2);
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollTo({ left, behavior });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cbx-kit-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cbx-kit-discovery')) {
  customElements.define('cbx-kit-discovery', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          const video = entry.target;
          if (entry.isIntersecting && !matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
          else video.pause();
        }
      }, { threshold: .25 });
      this.querySelectorAll('video').forEach(video => this.observer.observe(video));
    }
    disconnectedCallback() { this.observer?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cbx-starting-shade"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cbx-shade-finder')) {
    let indexPromise;
    customElements.define('cbx-shade-finder', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('change', () => this.render(), { signal: this.abort.signal });
        const load = async () => {
          try {
            indexPromise ||= fetch(this.dataset.url).then(response => {
              if (!response.ok) throw new Error('Shade data unavailable');
              return response.json();
            }).catch(error => { indexPromise = null; throw error; });
            this.shades = await indexPromise;
            if (this.isConnected) this.render();
          } catch {
            this.querySelector('#cbx-shade-results-title').textContent = 'Explore your colors';
            this.querySelector('#cbx-shade-summary').textContent = 'Use Explore all shades to download the ColorBox app.';
          }
        };
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            load();
          }
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
      render() {
        if (!this.shades) return;
        const bases = ['lightest-blonde', 'light-blonde', 'blonde', 'dark-blonde', 'light-brown'];
        const coverage = ['Sheer', 'Light', 'Medium', 'Rich', 'Full Coverage'];
        const base = this.querySelector('[data-base]:checked');
        const family = this.querySelector('[data-family]:checked');
        const allowed = coverage.slice(bases.indexOf(base.value));
        const results = this.shades.filter(shade => allowed.includes(shade.coverageLevel) && shade.colorFamilies.some(value => value.toLowerCase() === family.value));
        this.querySelector('#cbx-shade-results-title').textContent = `${results.length} colors you can create`;
        this.querySelector('#cbx-shade-summary').textContent = `${family.parentElement.textContent.trim()} possibilities for ${base.parentElement.textContent.trim()}.`;
        this.querySelector('#cbx-shade-count').textContent = `${results.length} shades in your range`;
        const palette = this.querySelector('#cbx-shade-palette');
        palette.replaceChildren(...results.map(shade => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'cbx-shade-chip';
          chip.style.setProperty('--shade-color', shade.hexColor);
          chip.dataset.shadeId = shade.shadeId;
          chip.dataset.hairLevelId = base.value;
          if (shade.hairRenderImage) {
            const image = document.createElement('img');
            image.src = `https://color-assets.zuviservices.com/${shade.hairRenderImage.replace('hairrender', 'hairrender_small')}`;
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            image.addEventListener('error', () => image.remove(), { once: true });
            chip.append(image);
          }
          chip.setAttribute('data-open-shade-dialog', '');
          chip.setAttribute('aria-label', `Shade ${shade.name}. Open shade explorer`);
          const label = document.createElement('span');
          const shadeName = String(shade.name ?? '');
          label.textContent = /^\d{4}$/.test(shadeName) ? `0${shadeName}` : shadeName;
          chip.append(label);
          return chip;
        }));
        palette.scrollTop = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
